export default function Footer() {
  return (
    <footer className="bg-black text-white text-center py-2">
      <p>&copy; {new Date().getFullYear()} KUxH | All rights reserved.</p>
    </footer>
  )
}
